import { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseTimeZone } from '../../../../common/hooks/useTimeZone'
import { Element } from '../../../../common/html/element'
import { Panel } from '../../../../common/panel'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { formatCurrencyFollowLocale } from '../../../../helpers/value'
import { EMPTY_VALUE } from '../../../../utils/common'
import { CURRENCY } from '../../../../utils/currency'
import { ORDER_TYPE } from '../../common/constants'
import { PopupPaymentInformation } from '../../common/popupPaymentInformation'
import { PAYMENT_METHOD } from '../../orderManagement/constants'
import { OrderStatusCell } from '../../orderManagement/table/OrderStatusCell'
import { PaymentStatusCell } from '../../orderManagement/table/PaymentStatusCell'
import { selectDetailRequestInfoAll } from '../store/slice'
import { getDetailRequestContract } from '../store/thunk'
import { REQUEST_INFO_SCHEMA } from './constants'

export const RequestInformation = ({ requestId, isPackageRequest }) => {
  const dispatch = useDispatch()

  const timeZone = UseTimeZone()

  const data = useSelector(selectDetailRequestInfoAll)
  const locale = useSelector((state) => state.i18n.locale)

  const [isOpenPayNow, setIsOpenPayNow] = useState(false)

  const leftSchema = isPackageRequest
    ? REQUEST_INFO_SCHEMA.leftSchema
    : REQUEST_INFO_SCHEMA.leftSchemaSubscription

  const rightSchema = isPackageRequest
    ? REQUEST_INFO_SCHEMA.rightSchema
    : REQUEST_INFO_SCHEMA.rightSchemaSubscription

  const handleDownloadContract = () => {
    dispatch(getDetailRequestContract({ Id: requestId }))
  }

  const renderRightHeader = () => {
    return (
      <Element
        elementName="span"
        style={{ color: '#2C73E8' }}
        className="cursorPointer"
        onClick={handleDownloadContract}
      >
        <Translate value="userManagement.packageSubManagement.DOWNLOAD_CONTRACT" />
      </Element>
    )
  }

  const handlePayNow = () => {
    setIsOpenPayNow(true)
  }

  return (
    <Panel
      label="userManagement.packageSubManagement.REQUEST_INFO"
      style={{ marginTop: 0 }}
      renderRightHeader={renderRightHeader}
      isI18n
    >
      <div className="dFlex p2">
        <div className="w50 dFlex">
          <div className="flexColumn gap2">
            {Object.values(leftSchema).map((item) => {
              return (
                <div className="fw600" key={item.key}>
                  <Translate value={item.title} />
                </div>
              )
            })}
          </div>
          <div className="flexColumn gap2 ml4">
            {Object.values(leftSchema).map((item, index) => {
              switch (item.key) {
                case leftSchema.dateRequested.key:
                  return (
                    <div key={index}>
                      {formatDateTime(
                        data[item.key],
                        FORMAT.DATE,
                        locale,
                        timeZone,
                      )}
                    </div>
                  )
                case leftSchema.requestStatus.key:
                  return (
                    <div key={index}>
                      <OrderStatusCell val={data[item.key]} />
                    </div>
                  )
                case leftSchema.paymentStatus.key:
                  return (
                    <PaymentStatusCell
                      key={index}
                      val={data[item.key]}
                      orderStatus={data?.status}
                      handlePayNow={handlePayNow}
                    />
                  )
                case leftSchema.paymentMethod.key:
                  return (
                    <Fragment key={index}>
                      {data[item.key] ? (
                        <div>
                          <Translate value={PAYMENT_METHOD[data[item.key]]} />
                        </div>
                      ) : (
                        <></>
                      )}
                    </Fragment>
                  )
                case 'dataPackageName':
                  return (
                    <div
                      key={index}
                      style={{
                        visibility: data[item.key] ? 'visible' : 'hidden',
                      }}
                    >
                      {data[item.key] || EMPTY_VALUE}
                    </div>
                  )
                case 'orderType':
                  return (
                    <div key={index}>
                      {data[item.key] ? (
                        <Translate
                          value={`subscriptionPayment.${data[item.key]}`}
                        />
                      ) : (
                        EMPTY_VALUE
                      )}
                    </div>
                  )
                case 'months':
                  const month = data[item.key]
                  if (!month) {
                    return <div key={index}>{EMPTY_VALUE}</div>
                  }
                  if (month === 1) {
                    return (
                      <div key={index}>
                        <Translate value="userManagement.packageSubManagement.MONTH" />
                      </div>
                    )
                  }
                  return (
                    <div key={index}>
                      <Translate
                        value="userManagement.packageSubManagement.MONTHS"
                        month={month}
                      />
                    </div>
                  )
                default:
                  return <div key={index}>{data[item.key] || EMPTY_VALUE}</div>
              }
            })}
          </div>
        </div>
        <div className="w50 dFlex">
          <div className="flexColumn gap2">
            {Object.values(rightSchema).map((item) => {
              return (
                <div className="fw600" key={item.key}>
                  <Translate value={item.title} />
                </div>
              )
            })}
          </div>
          <div className="flexColumn gap2 ml4">
            {Object.values(rightSchema).map((item, index) => {
              return (
                <div key={index}>
                  {formatCurrencyFollowLocale(
                    data[item.key],
                    CURRENCY.VND,
                    locale,
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
      {isOpenPayNow &&
        (data?.orderType === ORDER_TYPE.PACKAGE ? (
          <PopupPaymentInformation
            isShow={isOpenPayNow}
            setIsShow={setIsOpenPayNow}
            orderId={requestId}
            discountedAmount={data?.amount}
            discountValue={data?.discountValue}
            vatPrice={data?.vat}
            grandTotalPrice={data?.totalAmount}
            exchangeRateAPI={data?.exchangeRate}
            orderType={data?.orderType}
          />
        ) : (
          <PopupPaymentInformation
            isShow={isOpenPayNow}
            setIsShow={setIsOpenPayNow}
            orderId={requestId}
            oldPrice={data?.amount}
            discountedAmount={data?.discountedAmount}
            vatPrice={data?.vat}
            grandTotalPrice={data?.totalAmount}
            exchangeRateAPI={data?.exchangeRate}
            orderType={data?.orderType}
          />
        ))}
    </Panel>
  )
}
